<template>
  <Teleport to="body">
    <div class="register-page">
      <div class="register-card">
        <!-- Logo标题区域 和登录页保持一致 -->
        <div class="register-header">
          <img :src="avatarSrc" class="header‑avatar‑gif" alt="avatar" />
          <router-link to="/">
            <h1 class="logo-title">LupataID</h1>
          </router-link>
        </div>
        <form @submit.prevent="handleRegister" class="register-form">
          <!-- 邮箱 + 发送验证码 同一行 -->
          <div class="form-item email-row">
            <input
                v-model="form.username"
                type="email"
                placeholder="请输入邮箱地址"
                required
                @input="onUserInput"
            />
            <button
                type="button"
                class="send-code-btn"
                :disabled="countDown > 0"
                @click="sendVerifyCode"
            >
              {{ countDown > 0 ? `${countDown}s` : "发送验证码" }}
            </button>
          </div>

          <!-- 发送验证码后才显示：验证码输入框 -->
          <div v-if="showCodeInput" class="form-item">
            <input
                v-model="form.code"
                type="text"
                maxlength="6"
                placeholder="请输入6位验证码"
                required
                @input="onUserInput"
            />
          </div>

          <!-- 密码输入框 -->
          <div class="form-item password-wrap">
            <input
                v-model="form.password"
                :type="showPwd ? 'text' : 'password'"
                placeholder="请输入密码（至少6位）"
                required
                @input="onUserInput"
            />
            <span class="eye-icon" @click="showPwd = !showPwd">
              <svg class="icon" viewBox="0 0 1024 1024"
                                                                    xmlns="http://www.w3.org/2000/svg" width="25" height="25">
                <path d="M332.8 729.6l34.133333-34.133333c42.666667 12.8 93.866667 21.333333 145.066667 21.333333 162.133333 0 285.866667-68.266667 375.466667-213.333333-46.933333-72.533333-102.4-128-166.4-162.133334l29.866666-29.866666c72.533333 42.666667 132.266667 106.666667 183.466667 192-98.133333 170.666667-243.2 256-426.666667 256-59.733333 4.266667-119.466667-8.533333-174.933333-29.866667z m-115.2-64c-51.2-38.4-93.866667-93.866667-132.266667-157.866667 98.133333-170.666667 243.2-256 426.666667-256 38.4 0 76.8 4.266667 110.933333 12.8l-34.133333 34.133334c-25.6-4.266667-46.933333-4.266667-76.8-4.266667-162.133333 0-285.866667 68.266667-375.466667 213.333333 34.133333 51.2 72.533333 93.866667 115.2 128l-34.133333 29.866667z m230.4-46.933333l29.866667-29.866667c8.533333 4.266667 21.333333 4.266667 29.866666 4.266667 46.933333 0 85.333333-38.4 85.333334-85.333334 0-12.8 0-21.333333-4.266667-29.866666l29.866667-29.866667c12.8 17.066667 17.066667 38.4 17.066666 64 0 72.533333-55.466667 128-128 128-17.066667-4.266667-38.4-12.8-59.733333-21.333333zM384 499.2c4.266667-68.266667 55.466667-119.466667 123.733333-123.733333 0 4.266667-123.733333 123.733333-123.733333 123.733333zM733.866667 213.333333l29.866666 29.866667-512 512-34.133333-29.866667L733.866667 213.333333z"
                      :fill="showPwd?'var(--laputa-primary)':'var(--laputa-common-thirdary-font-color)'">
                </path></svg></span>
          </div>

          <!-- 确认密码 -->
          <div class="form-item password-wrap">
            <input
                v-model="form.confirmPwd"
                :type="showConfirmPwd ? 'text' : 'password'"
                placeholder="请再次输入密码"
                required
                @input="onUserInput"
            />
            <span class="eye-icon" @click="showConfirmPwd = !showConfirmPwd">
              <svg class="icon" viewBox="0 0 1024 1024"
                                                                                  xmlns="http://www.w3.org/2000/svg" width="25" height="25">
                <path d="M332.8 729.6l34.133333-34.133333c42.666667 12.8 93.866667 21.333333 145.066667 21.333333 162.133333 0 285.866667-68.266667 375.466667-213.333333-46.933333-72.533333-102.4-128-166.4-162.133334l29.866666-29.866666c72.533333 42.666667 132.266667 106.666667 183.466667 192-98.133333 170.666667-243.2 256-426.666667 256-59.733333 4.266667-119.466667-8.533333-174.933333-29.866667z m-115.2-64c-51.2-38.4-93.866667-93.866667-132.266667-157.866667 98.133333-170.666667 243.2-256 426.666667-256 38.4 0 76.8 4.266667 110.933333 12.8l-34.133333 34.133334c-25.6-4.266667-46.933333-4.266667-76.8-4.266667-162.133333 0-285.866667 68.266667-375.466667 213.333333 34.133333 51.2 72.533333 93.866667 115.2 128l-34.133333 29.866667z m230.4-46.933333l29.866667-29.866667c8.533333 4.266667 21.333333 4.266667 29.866666 4.266667 46.933333 0 85.333333-38.4 85.333334-85.333334 0-12.8 0-21.333333-4.266667-29.866666l29.866667-29.866667c12.8 17.066667 17.066667 38.4 17.066666 64 0 72.533333-55.466667 128-128 128-17.066667-4.266667-38.4-12.8-59.733333-21.333333zM384 499.2c4.266667-68.266667 55.466667-119.466667 123.733333-123.733333 0 4.266667-123.733333 123.733333-123.733333 123.733333zM733.866667 213.333333l29.866666 29.866667-512 512-34.133333-29.866667L733.866667 213.333333z"
                      :fill="showConfirmPwd?'var(--laputa-primary)':'var(--laputa-common-thirdary-font-color)'">
                </path></svg></span>
          </div>
          <!-- 注册主按钮 -->
          <button class="register-btn" type="submit" :disabled="loading">
            {{ loading ? "注册中…" : "注册并登录" }}
          </button>

          <!-- 底部跳转登录 -->
          <div class="bottom-link">
            <router-link to="/login" class="link-text">已有账号？返回登录</router-link>
          </div>
        </form>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, reactive, computed, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import request from "@/api/request";
import showToast from "@/utils/toast";

const router = useRouter();
const store  = useStore()
const loading = ref(false);
const showPwd = ref(false);
const showConfirmPwd = ref(false);
const countDown = ref(0);
// 控制验证码输入框显示
const showCodeInput = ref(false);
let timer = null;

// 头像资源路径，和登录页完全一致
const AVATAR = {
  default: new URL('@/assets/login-default.gif', import.meta.url).href,
  typing: new URL('@/assets/login-input.gif', import.meta.url).href,
  error: new URL('@/assets/login-fail.gif', import.meta.url).href,
  success: new URL('@/assets/login-success.gif', import.meta.url).href,
};
const isSuccessAvatar = ref(false);
const isErrorAvatar = ref(false);
const isInputAvatar = ref(false);
const isDefaultAvatar = ref(false);

const avatarSrc = computed(() => {
  if (isSuccessAvatar.value) return AVATAR.success;
  if (isErrorAvatar.value) return AVATAR.error;
  if (isInputAvatar.value && (form.username || form.password || form.confirmPwd || form.code)) return AVATAR.typing;
  return AVATAR.default;
});

// 用户输入清除错误
const onUserInput = () => {
  isErrorAvatar.value = false;
  isSuccessAvatar.value = false;
  isDefaultAvatar.value = false;
  isInputAvatar.value = true;
};

const form = reactive({
  username: "",
  code: "",
  password: "",
  confirmPwd: "",
});

// 发送验证码倒计时
const sendVerifyCode = async () => {
  if (!form.username) {
    showToast("请输入邮箱！")
    isErrorAvatar.value = true;
    return;
  }
  try {
    const response = await request.post("/v1/api/sendMessage", {username:form.username})
    const rsp = response.data
    console.log(rsp)
    if (rsp.responseCode !== '0000') {
      showToast(rsp.responseDesc)
      return;
    }
  } catch (e) {
    showToast(e.message)
    return;
  }
  // 发送成功，展示验证码输入框
  showCodeInput.value = true;
  countDown.value = 60;
  timer = setInterval(() => {
    countDown.value--;
    if (countDown.value <= 0) clearInterval(timer);
  }, 1000);
};

// 注册提交
const handleRegister = async () => {
  isErrorAvatar.value = false;
  isSuccessAvatar.value = false;
  loading.value = true;

  // 如果显示验证码框，则必须填写验证码
  if(showCodeInput.value && !form.code){
    showToast("请输入6位验证码！")
    isErrorAvatar.value = true;
    loading.value = false;
    setTimeout(() => {
      isInputAvatar.value = false
      isErrorAvatar.value = false
      isDefaultAvatar.value = true
    }, 2000)
    return;
  }

  if (form.password.length < 6) {
    showToast("密码至少6位！")
    isErrorAvatar.value = true;
    loading.value = false;
    setTimeout(() => {
      isInputAvatar.value = false
      isErrorAvatar.value = false
      isDefaultAvatar.value = true
    }, 2000)
    return;
  }
  if (form.password !== form.confirmPwd) {
    showToast("两次输入密码不一致！")
    isErrorAvatar.value = true;
    loading.value = false;
    setTimeout(() => {
      isInputAvatar.value = false
      isErrorAvatar.value = false
      isDefaultAvatar.value = true
    }, 2000)
    return;
  }

  loading.value = true;
  isErrorAvatar.value = false
  isSuccessAvatar.value = false
  try {
    await store.dispatch("userInfo/register", form)
    isSuccessAvatar.value = true
    showToast("注册成功！即将登陆..","success")
    setTimeout(() => {
      router.replace("/")
    }, 600)
  } catch (e) {
    showToast(e.message)
    isErrorAvatar.value = true
    setTimeout(() => {
      isInputAvatar.value = false
      isErrorAvatar.value = false
      isDefaultAvatar.value = true
    }, 2000)
  } finally {
    loading.value = false;
  }
};

// 组件销毁清除定时器
onUnmounted(() => {
  if (timer) clearInterval(timer);
});
</script>

<style scoped>
.register-page {
  position: relative;
  min-height: 100vh;
  background-color: var(--laputa-body-background);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 20px 16px;
}

.register-page::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--background-image);
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.08;
  z-index: 0;
}

.register-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  box-sizing: border-box;
}

.register-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 40px;
}

.header‑avatar‑gif {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid transparent;
}

.logo-title {
  font-size: var(--laputa-fontsize-28);
  margin: 0;
  font-weight: 600;
  color: var(--laputa-common-font-color);
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-item {
  position: relative;
}

.form-item input {
  width: 100%;
  height: 48px;
  padding: 0 20px;
  border: 1px solid var(--laputa-glass-header-separator);
  border-radius: 999px;
  box-sizing: border-box;
  transition: border 0.2s;
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-thirdary-font-color);
  background: var(--laputa-glass-background);

}

.form-item input:focus {
  outline: none;
  border-color: var(--laputa-primary);
  background: var(--laputa-body-background);
}

/* 邮箱输入框+发送验证码同一行 */
.email-row {
  display: flex;
  gap: 12px;
}
.email-row input {
  flex: 1;
}
.send-code-btn {
  white-space: nowrap;
  height: 48px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid var(--laputa-glass-header-separator);
  cursor: pointer;
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-thirdary-font-color);
  background: var(--laputa-glass-background);
  min-width: 80px;
}
.send-code-btn:disabled {
  cursor: not-allowed;
}

.password-wrap .eye-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #888;
  display: flex;
  align-items: center;
}

.privacy-desc p {
  margin: 4px 0;
}
.register-btn {
  height: 50px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 8px;
  background-color: var(--laputa-svg-color);
  color: var(--laputa-common-inverse-font-color);
  font-size: var(--laputa-fontsize-15);
}
.register-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bottom-link {
  text-align: center;
  margin-top: 6px;
  font-size:14px;
}
.link-text {
  color: var(--laputa-common-sub-font-color);
  text-decoration: none;
}
.link-text:hover {
  text-decoration: underline;
}

/* ========== 平板适配 768px‑1024px ========== */
@media (max-width: 1024px) {
  .register-page::before {
    background-size: 100%;
  }
  .register-header {
    margin-bottom: 32px;
  }
  .logo-title {
    font-size: 22px;
  }
}

/* ========== 手机端适配 <768px ========== */
@media (max-width: 768px) {
  .register-page::before {
    background-size: 100%;
    opacity: 0.07;
  }
  .register-header {
    margin-bottom: 28px;
    gap: 8px;
  }
  .logo-title {
    font-size: 20px;
  }
  .form-item input {
    height: 44px;
  }
  .send-code-btn {
    padding: 0 12px;
    font-size:13px;
    height:44px;
  }
  .register-btn {
    height: 46px;
  }
}
</style>